<template>
  <div v-if="presence && presence.state !== 'present'" class="alert alert-warning small my-2" role="status">
    <strong>{{ presence.needsReview ? 'Review listing absence' : inactive ? 'Listing is inactive' : 'Missing from latest extract' }}</strong>
    <p class="mb-1">
      Absent from {{ presence.missedSnapshotCount }} complete daily snapshots.
      <span v-if="presence.lastSeenSnapshotDate">Last seen in an extract: {{ presence.lastSeenSnapshotDate }}.</span>
    </p>
    <p v-if="presence.needsReview" class="mb-0">
      This listing is linked to a verified property and remains active. Check the source listing, then choose Keep active or Listing is not active.
    </p>
    <p v-else-if="manualOverride" class="mb-0">Your manual status choice is preserved.</p>
    <p v-else-if="inactive && deactivation" class="mb-0">
      Automatically deactivated after {{ deactivation.missedSnapshotCount }} missing daily snapshots on {{ deactivation.snapshotDate }}.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    presence: { type: Object, default: null },
    deactivation: { type: Object, default: null },
    inactive: Boolean,
    manualOverride: Boolean
  }
};
</script>
